import * as React from 'react';
import { type FC } from 'react';

import { use$ } from '@legendapp/state/react';
import { Richtext, Text, TokenTextAppearance, styled } from '@volkswagen-onehub/components-core';

import { useAssetBundles } from '../hooks/use-asset-bundles';

import { rootStore } from '../store';
import { AssetBundlesTable } from './table/asset-bundles-table';
import { VariantTable } from './table/variant-table';

const EditorMode: FC = () => {
	const bffData = rootStore.bffData.get();
	const { data: assetBundlesResponse, error: assetBundlesError, isLoading: isAssetBundlesLoading } = useAssetBundles();

	const variants = use$(bffData?.assets ? Object.keys(bffData.assets) : []);
	const [isVariantSectionOpen, setIsVariantSectionOpen] = React.useState(true);
	const [isAssetBundlesSectionOpen, setIsAssetBundlesSectionOpen] = React.useState(true);

	return (
		<>
			<AccordionSection>
				<AccordionHeader
					onClick={() => setIsVariantSectionOpen(previous => !previous)}
					aria-expanded={isVariantSectionOpen}
					aria-controls="editor-mode-variant-table"
					type="button"
				>
					<Text appearance={TokenTextAppearance.headline300} bold>
						<Richtext markdown={`Variant List`} />
					</Text>
					<Icon aria-hidden $isOpen={isVariantSectionOpen}>
						▼
					</Icon>
				</AccordionHeader>
				{isVariantSectionOpen && (
					<AccordionContent id="editor-mode-variant-table">
						<VariantTable assets={bffData?.assets} variantKeys={variants} />
					</AccordionContent>
				)}
			</AccordionSection>

			<AccordionSection>
				<AccordionHeader
					onClick={() => setIsAssetBundlesSectionOpen(previous => !previous)}
					aria-expanded={isAssetBundlesSectionOpen}
					aria-controls="editor-mode-asset-bundles-table"
					type="button"
				>
					<Text appearance={TokenTextAppearance.headline300} bold>
						<Richtext markdown={`Vehicle bundles catalogue`} />
					</Text>
					<Icon aria-hidden $isOpen={isAssetBundlesSectionOpen}>
						▼
					</Icon>
				</AccordionHeader>
				{isAssetBundlesSectionOpen && (
					<AccordionContent id="editor-mode-asset-bundles-table">
						<AssetBundlesTable
							data={assetBundlesResponse}
							isLoading={isAssetBundlesLoading}
							error={assetBundlesError}
						/>
					</AccordionContent>
				)}
			</AccordionSection>
		</>
	);
};

const AccordionSection = styled.section`
	margin: 20px;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 8px;
`;

const AccordionHeader = styled.button`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: none;
	border: none;
	padding: 20px;
	cursor: pointer;
	text-align: left;
`;

const Icon = styled.span<{ $isOpen: boolean }>`
	display: inline-block;
	transform: rotate(${props => (props.$isOpen ? '180deg' : '0deg')});
`;

const AccordionContent = styled.div`
	padding: 0 20px 20px;
`;

export default EditorMode;
